// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  baseWeb: 'https://test-bcp.setstage.or.th',
  baseUrl: 'https://test-bcp.setstage.or.th/api',
  acknowledgeImage: 'https://test.enterprise.set.or.th/EnterpriseApp/EmpPhoto',
  hrEndpoint: 'https://test-hr.setstage.or.th',
  hrPortalEndpoint: 'https://test.portal.setstage.or.th/hr-portal',
  activateBCPNotificationChannel: 'TEST',
  msalClientId: 'b6b5ff4f-129d-4a31-a5b4-daa73c11fb58',
  local: false
}
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
